import html from 'text!modules/jquery.multiSelectorTemplate.html';
import $ from 'jquery';

function multiSelector($multiSelector, customOptions) {
  const options = {
    onInit: function(selectedItems) {},
    onItemsSelected: function(selectedItems) {},
    availableItems: [],
    selectedItems: []
  };

  if (customOptions) {
    $.extend(options, customOptions);
  }

  $multiSelector.html(html);
  const $container = $multiSelector.find('.multi-selector').first();
  const selectedItems = options.selectedItems.slice(0);
  const availableItems = options.availableItems.slice(0);
  renderSelector(selectedItems, availableItems, $container, options.onItemsSelected);
  options.onInit(selectedItems);

  function renderSelector(selectedItems, availableItems, container, onItemsSelected) {
    container.uniqueId();
    const uniqueId = container.attr('id');

    function isSelected(item) {
      return (
        selectedItems.findIndex(
          selectedItem => parseInt(item.code) === parseInt(selectedItem.code)
        ) !== -1
      );
    }

    $.each(availableItems, function(i, item) {
      container.append(
        '<div class="multi-selector-item" >' +
          '<input class="multi-checkbox" data-code="' +
          item.code +
          '" type="checkbox" ' +
          (isSelected(item) ? 'checked' : '') +
          ' id="' +
          uniqueId +
          '-' +
          item.code +
          '"/>' +
          '<div class="label-wrapper"><label for="' +
          uniqueId +
          '-' +
          item.code +
          '"><span class="visible-checkbox icon-checkmark" data-code="' +
          item.code +
          '"></span><span class="item-label">' +
          item.label +
          '</span></label></div></div>'
      );
    });

    $multiSelector.find('.multi-checkbox').change(function() {
      const $currentCheckbox = $(this);
      const checkboxCode = $currentCheckbox.attr('data-code');
      if ($currentCheckbox.is(':checked')) {
        const checkedCode = availableItems.find(
          item => parseInt(item.code) === parseInt(checkboxCode)
        );

        if (checkedCode && selectedItems.indexOf(checkedCode) === -1) {
          selectedItems.push(checkedCode);
        }
      } else {
        selectedItems = selectedItems.filter(
          item => parseInt(item.code) !== parseInt(checkboxCode)
        );
      }
      onItemsSelected(selectedItems);
    });

    $multiSelector.find('.multi-checkbox').on('uncheckAll', function() {
      selectedItems.length = 0;
      onItemsSelected(selectedItems);
    });
  }
}

// exposition sous forme de module jQuery
$.fn.extend({
  multiSelector: function(customOptions) {
    return this.each(function() {
      multiSelector($(this), customOptions);
    });
  }
});
